import React, { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { downloadFile } from "@/components/shipment/ReportButtons";

const thisMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const MonthlyReport = () => {
  const [month, setMonth] = useState(thisMonth());
  const [busy, setBusy] = useState(false);
  return (
    <div data-testid="monthly-report" className="flex flex-col sm:flex-row sm:items-center gap-2">
      <Input data-testid="input-report-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)}
             style={{ colorScheme: "dark" }} className="w-full sm:w-44 bg-slate-950 border-slate-700" />
      <Button data-testid="button-monthly-pdf" disabled={!month || busy} className="bg-emerald-600 hover:bg-emerald-500"
              onClick={() => downloadFile(`/reports/completed.pdf?month=${month}`, `completed-shipments-${month}.pdf`, () => setBusy(true), () => setBusy(false))}>
        {busy ? <Loader2 size={14} className="mr-2 animate-spin" /> : <FileDown size={14} className="mr-2" />} Monthly summary PDF
      </Button>
    </div>
  );
};

export const RowPdf = ({ sh }) => {
  const [busy, setBusy] = useState(false);
  return (
    <Button data-testid={`row-pdf-${sh.id}`} size="sm" variant="outline" disabled={busy} className="h-7 px-2 border-slate-700 hover:bg-slate-800"
            onClick={() => downloadFile(`/shipments/${sh.id}/report.pdf`, `${sh.shipment_number}-report.pdf`, () => setBusy(true), () => setBusy(false))}>
      {busy ? <Loader2 size={12} className="mr-1 animate-spin" /> : <FileDown size={12} className="mr-1" />} PDF
    </Button>
  );
};
